import React from 'react';

import { Button } from './styles';

export function KnowMoreCTA({ onClick }) {
  return (
    <Button type="button" onClick={onClick}>Saiba mais</Button>
  );
}
